import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../Slices/auth';
import LogoutIcon from '@mui/icons-material/Logout';

const AuthNav = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const logout = (e) => {
        e.preventDefault();
        dispatch(logoutUser());
        navigate('/');
    };

    return (
        <header className="site-header">
            <style>{`
                .auth-nav-custom {
                    background: linear-gradient(135deg, #1d7bc4 0%, #228bdf 100%);
                    padding: 12px 0;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                }

                /* Container optimization for custom layout pinning */
                .nav-flex-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: space-between; /* Keeps brand on left, logout on right */
                    width: 100%;
                }

                .auth-brand {
                    font-size: 1.5rem;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    color: #ffffff !important;
                    text-decoration: none;
                    display: block;
                }

                .logout-btn-wrapper {
                    margin-left: auto; /* Guarantees layout pushes completely to the right edge */
                }

                .logout-btn-custom {
                    background: rgba(255, 255, 255, 0.15);
                    color: #ffffff !important;
                    border: 1px solid transparent;
                    border-radius: 30px;
                    padding: 8px 20px;
                    font-size: 0.95rem;
                    font-weight: 600;
                    text-decoration: none;
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    transition: all 0.3s ease;
                }

                .logout-btn-custom:hover {
                    background: #ef4444; 
                    box-shadow: 0 4px 10px rgba(239, 68, 68, 0.4);
                    color: #ffffff !important;
                    transform: translateY(-1px);
                }

                /* Mobile Handling Strategy */
                @media (max-width: 767px) {
                    .auth-brand {
                        display: none !important; /* Completely hide JKUSDA brand on mobile views */
                    }
                    .nav-flex-wrapper {
                        justify-content: flex-end; /* Force layout alignment purely right-bound */
                    }
                }
            `}</style>

            <nav className="navbar navbar-expand-md fixed-top auth-nav-custom">
                <div className="container">
                    <div className="nav-flex-wrapper">
                        {/* Brand element - automatically displays on web, hides on mobile */}
                        <a className="auth-brand" href="#/">
                            JKUSDA
                        </a>

                        {/* Logout Element - dynamically pinned to the right edge across all viewports */}
                        <div className="logout-btn-wrapper">
                            <a className="logout-btn-custom" href="#/" role="button" onClick={logout}>
                                <span>Logout</span>
                                <LogoutIcon sx={{ fontSize: 18 }} />
                            </a>
                        </div>
                    </div>
                </div>
            </nav>
            
            <br />
            <br />
            <br />
        </header>
    );
};

export default AuthNav;